import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { actions } from '../../../../store/reducers/assignment.reducer'
import { connect } from 'react-redux'
import { useParams } from 'react-router'
import { Card, Table, Tooltip } from 'antd'
import { percentToColor } from '../../../../utils/colors.helper'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'

const HeatmapReportSection = ({ assignment, groupsUnitTestsReportData, fetchGroupsUnitTestsReportData }) => {
    useDocumentTitle(`${assignment.assignment_name || ''} Heatmap`)

    const { token } = useParams()
    const [isWaitingForGroupsUnitTestsReportData, setIsWaitingForGroupsUnitTestsReportData] = useState(false)

    useEffect(() => {
        ;(async () => {
            setIsWaitingForGroupsUnitTestsReportData(true)
            await fetchGroupsUnitTestsReportData(token)
            setIsWaitingForGroupsUnitTestsReportData(false)
        })()
    }, [token])

    const groupsUnitTestsReportTableColumns = [
        {
            title: 'Test',
            dataIndex: 'test',
            key: 'test',
        },
    ]

    const groupsUnitTestsReportTableData = []

    if (groupsUnitTestsReportData) {
        const reportData = []
        let columnsData
        const groupedFiles = _(groupsUnitTestsReportData.cluster_files)
            .groupBy('file_id')
            .map((v, file_id) => ({
                file_id: parseInt(file_id),
                clusters: _.map(v, 'layer_cluster'),
            }))
            .value()

        const grouped_clusters = _(groupedFiles)
            .groupBy('clusters')
            .map((v, clusters) => ({
                clusters: clusters.split(','),
                files: _.map(v, 'file_id'),
            }))
            .value()
            .sort((a, b) => b.files.length - a.files.length)
            .slice(0, 10)

        groupsUnitTestsReportData.uts_definition.forEach(ut_obj => {
            let ut_name_txt = ut_obj.ut_name
            reportData.push([ut_name_txt])

            grouped_clusters.forEach(gc => {
                const ut_files = _(
                    _(groupsUnitTestsReportData.ut_results)
                        .filter(function (ut) {
                            return (
                                parseInt(ut.ut_id) === parseInt(ut_obj.ut_id) && gc.files.includes(parseInt(ut.file_id))
                            )
                        })
                        .value(),
                ).each(ut => (ut.ut_passed = parseInt(ut.ut_passed)))

                const ut_passed_sum = _.sumBy(ut_files, 'ut_passed')
                const ut_files_total = ut_files.length
                gc.total = ut_files_total

                const rep_row = Math.round((100 * ut_passed_sum) / ut_files_total)
                reportData[reportData.length - 1].push(isNaN(rep_row) ? '-' : `${rep_row}%`)
            })
        })

        columnsData = _.map(grouped_clusters, c => {
            return { names: c.clusters, total: c.total }
        })

        columnsData.map((columnData, index) => {
            const tooltipText = columnData.names.map(name => {
                const [layerId, clusterId] = name.split('-')
                const layerName = groupsUnitTestsReportData.layers.find(
                    layer => layer.layer_id === Number(layerId),
                ).layer_name
                const clusterName = groupsUnitTestsReportData.clusters.find(
                    cluster => cluster.cluster_id === Number(clusterId),
                ).cluster_name
                return (
                    <>
                        [{layerName}] {clusterName}
                        <br />
                    </>
                )
            })
            tooltipText.unshift(
                <>
                    {columnData.total} submissions in:
                    <br />
                </>,
            )

            groupsUnitTestsReportTableColumns.push({
                title: (
                    <Tooltip title={tooltipText} placement='bottom'>
                        {columnData.total}
                    </Tooltip>
                ),
                dataIndex: `column_${index}`,
                key: `column_${index}`,
                width: '8%',
                render: percent => {
                    return {
                        props: {
                            style: {
                                backgroundColor: percent === '-' ? '#fff' : percentToColor(percent.slice(0, -1), 0.8),
                            },
                        },
                        children: <div style={{ fontWeight: 600, color: 'black' }}>{percent}</div>,
                    }
                },
            })
        })
        reportData.map((item, index) => {
            groupsUnitTestsReportTableData.push({
                key: index,
                test: item[0],
                column_0: item[1],
                column_1: item[2],
                column_2: item[3],
                column_3: item[4],
                column_4: item[5],
                column_5: item[6],
                column_6: item[7],
                column_7: item[8],
                column_8: item[9],
                column_9: item[10],
            })
        })
    }
    return (
        <div className='heatmap-report-section'>
            <Card title='Groups & Tests'>
                <p>
                    Displaying percentage of passed tests in top groups across components. Hover over columns labels for
                    more data.
                </p>
                <Table
                    columns={groupsUnitTestsReportTableColumns}
                    dataSource={groupsUnitTestsReportTableData}
                    pagination={false}
                    loading={isWaitingForGroupsUnitTestsReportData}
                    scroll={{ x: true }}
                />
            </Card>
        </div>
    )
}

const mapState = ({ assignment }) => {
    return {
        assignment: assignment.assignment,
        groupsUnitTestsReportData: assignment.groupsUnitTestsReportData,
    }
}

const mapDispatch = dispatch => {
    return {
        fetchGroupsUnitTestsReportData: token => {
            return dispatch(actions.fetchGroupsUnitTestsReportData(token))
        },
    }
}

export default connect(mapState, mapDispatch)(HeatmapReportSection)
